<template>
  <div>
    <div class="col-12 text-center p-0">
      <div class="d-flex flex-column">
        <div
          v-tooltip="{
            content: isInThePast
              ? $t('EVENTS.TEXT.PAST_EVENTS_CAN_NOT_BE_STARTED')
              : '',
            delay: 100,
            placement: 'top',
            container: 'body',
          }"
        >
          <HMButton
            v-if="!isStreaming"
            color="brand text-nowrap w-100"
            :disabled="
              !isTokboxEnabled ||
              startingStreamingSession ||
              isInThePast ||
              isFreeEvent
            "
            @click="startStreamingSession()"
            :loading="startingStreamingSession"
          >
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <span class="d-flex flex-grow-1">
                {{ $t('EVENTS.BUTTON.START_BROADCAST') }}
              </span>
              <span
                class="button-image-container d-flex flex-grow-0 justify-content-center"
              >
                <img
                  class="img-fluid img-restrict"
                  src="/assets/images/hey-marvelous-rainbow.png"
                />
              </span>
            </div>
          </HMButton>
        </div>
        <HMButton
          v-if="isStreaming"
          color="brand end text-nowrap w-100"
          :disabled="stoppingStreamingSession"
          @click="stopStreamingSession()"
          :loading="stoppingStreamingSession"
        >
          <div class="d-flex justify-content-between align-items-center w-100">
            <span class="d-flex flex-grow-1">
              {{ $t('EVENTS.BUTTON.STOP_BROADCAST') }}
            </span>
            <span
              class="button-image-container d-flex flex-grow-0 justify-content-center"
            >
              <img
                class="img-fluid img-restrict"
                src="/assets/images/hey-marvelous-rainbow.png"
              />
            </span>
          </div>
        </HMButton>
        <div class="text-left" v-if="!isTokboxEnabled">
          <small
            class="text-muted mt-2"
            v-html="
              sanitize(
                $t('EVENTS.TEXT.BROWSER_STREAMING_DISABLED_WARNING', {
                  applicationName,
                })
              )
            "
          >
          </small>
          <div v-if="isZoomConnected">
            <small class="text-muted mt-2">
              {{ $t('EVENTS.TEXT.USE_ZOOM_TO_CONTINUE_STREAMING') }}
            </small>
          </div>
          <div v-else>
            <small
              class="text-muted mt-2"
              v-html="
                sanitize($t('EVENTS.TEXT.CONNECT_ZOOM_TO_CONTINUE_STREAMING'))
              "
            >
            </small>
          </div>
        </div>
        <div class="text-left" v-if="isFreeEvent">
          <small
            class="text-muted mt-2"
            v-html="
              sanitize(
                $t('EVENTS.TEXT.BROWSER_STREAMING_DISABLED_FOR_FREE_EVENTS')
              )
            "
          >
          </small>
          <div v-if="isZoomConnected">
            <small class="text-muted mt-2">
              {{ $t('EVENTS.TEXT.USE_ZOOM_TO_CONTINUE_STREAMING') }}
            </small>
          </div>
          <div v-else>
            <small
              class="text-muted mt-2"
              v-html="
                sanitize($t('EVENTS.TEXT.CONNECT_ZOOM_TO_CONTINUE_STREAMING'))
              "
            >
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorToMessage } from '../../../core/utils/errors';
import * as EventUtils from '../../../core/utils/events';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { getConfig } from '@/web/utils/configuration';
import { sanitize } from '@/core/utils/utils';

export default {
  name: 'EventBrowserStreamingComponent',
  props: {
    event: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({
      isZoomConnected: 'user/isZoomConnected',
      isTokboxEnabled: 'user/isTokboxEnabled',
    }),
    isSoon() {
      const now = moment();
      const eventStartTime = moment(this.event.event_start_datetime);
      return now.add(1, 'h').isAfter(eventStartTime);
    },
    isInThePast() {
      const now = moment();
      const eventDate = moment(this.event.event_end_datetime).add(1, 'day');
      return now.isAfter(eventDate);
    },
    streamOptions() {
      return EventUtils.getEventStreamOptions(this.event.event_type);
    },
    isStreaming() {
      return (
        this.event.streaming_session_id !== null &&
        this.event.streaming_session_id !== ''
      );
    },
    applicationName() {
      return getConfig().applicationName;
    },
    isFreeEvent() {
      return this.event.is_free_event;
    },
  },
  data() {
    return {
      creatingSession: false,
      startingStreamingSession: false,
      stoppingStreamingSession: false,
    };
  },
  methods: {
    sanitize,
    async stopStreamingSession() {
      this.stoppingStreamingSession = true;
      try {
        await this.$store.dispatch('event/stopStreamingSession', this.event.id);
      } finally {
        this.stoppingStreamingSession = false;
      }
    },
    async startStreamingSession() {
      this.startingStreamingSession = true;
      try {
        await this.$store.dispatch(
          'event/startStreamingSession',
          this.event.id
        );
        try {
          this.$modal.hideAll();
          // eslint-disable-next-line no-empty
        } catch (err) {}
        this.$router.push({
          name: 'live-streaming',
          params: { id: this.event.id },
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to start the streaming session',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.startingStreamingSession = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.button-image-container {
  background-color: $white;
  border: 1px solid $medium-gray;
  border-left-color: transparent;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  min-height: 41px;
  margin: -9px -14px;
  padding: 8px 20px;
  min-width: 110px;

  .img-restrict {
    max-width: 90px;
    max-height: 24px;
  }
}
</style>
